import Link from '@atoms/Link'
import ArrowLeft from '@icons/ArrowLeft'
import ArrowRitght from '@icons/ArrowRight'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type PagerProps = {
  totalPage: number
  page: number
}
const Pager = ({ totalPage, page }: PagerProps) => {
  const { t, path } = useTranslation()

  const uiPageList =
    totalPage >= 7
      ? getPageList(page, totalPage)
      : Array.from({ length: totalPage }, (_, i) => i + 1)

  return (
    <div className={style.pager}>
      <div className={style.status}>
        {page} / {totalPage} {t('pagination.pages')}
      </div>
      <div className={style.ui}>
        {page === 1 ? (
          <div className={style.arrowContainer}>
            <div className={style.arrow} aria-disabled>
              <ArrowLeft />
            </div>
          </div>
        ) : (
          <div
            className={style.arrowContainer}
            data-gtm-click="article-pager-prev"
            data-gtm-label={page - 1}
          >
            <Link to={`${path}?page=${page - 1}`} className={style.arrow}>
              <ArrowLeft />
            </Link>
          </div>
        )}

        {uiPageList.map((uiPage, index) =>
          uiPage === undefined ? (
            <div className={style.dot} key={`ui-${index}-undefined`}>
              ...
            </div>
          ) : (
            <div
              className={style.numberContainer}
              data-gtm-click="article-pager-numbers"
              data-gtm-label={uiPage}
              key={`ui-${index}-${uiPage}}`}
            >
              <Link
                to={`${path}?page=${uiPage}`}
                className={`${style.number}${
                  uiPage === page ? ` ${style.active}` : ''
                }`}
              >
                {uiPage}
              </Link>
            </div>
          ),
        )}

        {page === totalPage ? (
          <div className={style.arrowContainer}>
            <div className={style.arrow} aria-disabled>
              <ArrowRitght />
            </div>
          </div>
        ) : (
          <div
            className={style.arrowContainer}
            data-gtm-click="article-pager-next"
            data-gtm-label={page + 1}
          >
            <Link to={`${path}?page=${page + 1}`} className={style.arrow}>
              <ArrowRitght />
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

const getPageList = (page: number, totalPage: number) => {
  switch (page) {
    case 1:
    case 2:
    case 3:
      return [1, 2, 3, 4, undefined, totalPage]
    case totalPage - 2:
    case totalPage - 1:
    case totalPage:
      return [
        1,
        undefined,
        totalPage - 3,
        totalPage - 2,
        totalPage - 1,
        totalPage,
      ]
    default:
      return [1, undefined, page - 1, page, page + 1, undefined, totalPage]
  }
}

export default Pager
